import { get } from 'lodash'
import groupBy from 'lodash/groupBy'

import { employeeUser } from 'modules/core/store/collections/users'

import employeesCollection from 'modules/employees/store/collections/employees'
import Holidays from 'modules/shift_management/store/internal/collections/Holidays'
import Leaves from 'modules/shift_management/store/internal/collections/Leaves'
import PlanningVersions from 'modules/shift_management/store/internal/collections/PlanningVersions'
import RestDays from 'modules/shift_management/store/internal/collections/RestDays'
import Shifts from 'modules/shift_management/store/internal/collections/Shifts'
import { LeavePayload } from 'modules/shift_management/store/internal/models/Leave'
import { PlanningVersionPayload } from 'modules/shift_management/store/internal/models/PlanningVersion'
import { RestDayPayload } from 'modules/shift_management/store/internal/models/RestDay'
import { ShiftPayload } from 'modules/shift_management/store/internal/models/Shift'
import ShiftPermissions from 'modules/shift_management/store/internal/models/ShiftPermissions'
import ShiftsRow, { ShiftsRowType } from 'modules/shift_management/store/internal/models/ShiftsRow'
import type CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

import { EmployeePermissions } from './types'

const buildEmployeeParamsFromResources = (
  employees: EmployeePermissions[],
  leaves: Array<LeavePayload> | undefined,
  planningVersions: Array<PlanningVersionPayload> | undefined,
  shifts: Array<ShiftPayload> | undefined,
  companyHolidays: CompanyHoliday[],
  restDays: Array<RestDayPayload> | undefined
): ShiftsRow[] => {
  if (!employees) {
    return []
  }

  const groupedLeaves = groupBy(leaves, (leave) => leave.employee_id)
  const groupedPlanningVersions = groupBy(planningVersions, (pv) => pv.employee_id)
  const groupedShifts = groupBy(shifts, (shift) => shift.employee_id)
  const groupedHolidays = groupBy(companyHolidays, (holiday) => holiday.attributes.location_id)
  const groupedRestDays = groupBy(restDays, (restDay) => restDay.employee_id)

  return employees.map((employee) => {
    const id = employee.id
    const collectionEmployee = employeesCollection.find({ id })
    const employeeAvatar =
      (collectionEmployee && employeeUser(collectionEmployee).attributes.avatar) || ''
    const fullName = (collectionEmployee && employeeUser(collectionEmployee).fullName()) || ''
    const locationId = collectionEmployee ? collectionEmployee.attributes.location_id : null
    const holidays = locationId ? get(groupedHolidays, locationId, []) : []

    return new ShiftsRow({
      id,
      type: ShiftsRowType.employee,
      title: fullName,
      // @deprecated: Since we are not using the job from REST, migrated to GraphQL
      job: '',
      avatar: employeeAvatar,
      permissions: ShiftPermissions.buildFromRequest(employee.permissions),
      shifts: Shifts.buildFromRequest(groupedShifts[id] ?? []),
      leaves: Leaves.buildFromProps(groupedLeaves[id] ?? []),
      holidays: Holidays.buildFromProps(holidays),
      restDays: RestDays.build(groupedRestDays[id] ?? []),
      planningVersions: PlanningVersions.buildFromProps(groupedPlanningVersions[id] ?? []),
    })
  })
}

export default buildEmployeeParamsFromResources
